

export const vLength = (
  rule,
  val,
) => {
  if (!val) return null;

  if (rule.min && val.length < rule.min) return rule.message || null;
  if (rule.max && val.length > rule.max) return rule.message || null;

  return null;
};
